<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex xs12 sm6>
        <v-btn
          depressed
          :outline="filter != 'all'"
          :color="filter == 'all' ? 'primary' : 'grey'"
          class="ma-0 mr-1 mb-1"
          @click="filter = 'all'"
          >{{ $t('All') }}</v-btn
        >
        <v-btn
          depressed
          :outline="filter != 'facebook'"
          :color="filter == 'facebook' ? 'primary' : 'grey'"
          class="ma-0 mr-1 mb-1"
          @click="filter = 'facebook'"
        >
          <em class="fab fa-facebook-square mr-1" />
          {{ $t('Facebook') }}
        </v-btn>
        <v-btn
          depressed
          :outline="filter != 'line'"
          :color="filter == 'line' ? 'primary' : 'grey'"
          class="ma-0 mr-1 mb-1"
          @click="filter = 'line'"
        >
          <em class="fab fa-line mr-1" />
          {{ $t('Line') }}
        </v-btn>
      </v-flex>
      <v-flex xs12 sm6 class="text-sm-right">
        <template v-if="loading">
          <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
        </template>
        <template v-else>
          <v-btn
            v-if="$store.getters.getPackage != 'premium'"
            v-tooltip.top="'Unlock to PREMIUM plan'"
            outline
            color="grey"
            class="ma-0 mb-1"
          >
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
            <v-premium-lock></v-premium-lock>
          </v-btn>
          <v-btn
            v-else-if="$store.getters.getPackage == 'premium'"
            color="grey"
            outline
            class="ma-0 mb-1"
            @click="exportDashboard"
          >
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
          </v-btn>
        </template>
      </v-flex>
    </v-layout>
    <date-filter v-model="selectedDate" :default-filter="'this_month'"></date-filter>
    <!-- {{selectedMenu}} -->
    <!-- <v-row align="center">
    <v-col cols="12">
      <v-select
        class="title"
        v-model="selectedMenu"
        :items="type"
        item-text="title"
        return-object
        :menu-props="{ top: true, offsetY: true }"
      ></v-select>
    </v-col>
  </v-row> -->

    <h3 style="margin: 0.5em" class="title">{{ $t(type[index].title) }}</h3>
    <TagReportGraph
      v-if="data.length"
      :selected-date="sortedDate"
      :loading="loading"
      :data="data"
    />
  </v-container>
</template>

<script>
import DateFilter from './../DateFilter'
import TagReportGraph from './InboxStatGraph'

import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'

export default {
  components: {
    DateFilter,
    TagReportGraph
  },
  data() {
    return {
      index: 0,
      type: [
        { title: 'คำถามเกี่ยวกับการสมัครเรียน', func: 'getbudashboardregisterquestion' },
        { title: 'คณะที่ถูกถาม', func: 'getbudashboardfaculty' },
        { title: 'ทุนการศึกษาที่ถูกถาม', func: 'getbudashboardscholarships' }
      ],
      filter: 'all',
      loading: false,
      selectedDate: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD')
      },
      data: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    sortedDate() {
      return this.data.slice(0).sort((a, b) => b.count - a.count)
    }
  },
  watch: {
    selectedDate: {
      handler: function () {
        this.getRow(this.type[this.index])
      },
      deep: true
    },
    filter() {
      this.getRow(this.type[this.index])
    },
    index() {
      this.getRow(this.type[this.index])
    },
    selectedMenu() {
      this.getRow(this.selectedMenu)
    }
  },
  mounted() {
    this.getRow(this.type[this.index])
  },
  methods: {
    getRow(item) {
      let vm = this
      vm.loading = true
      api[item.func](
        { ...this.selectedDate, filter: vm.filter, pageid: vm.selectedBot.pageid },
        function (error, response) {
          vm.loading = false
          if (error) {
            console.error(error)
            return
          }
          if (response.responsecode == 200) {
            vm.data = response.data
          }
        }
      )
    },
    exportDashboard: function () {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }

      if (vm.selectedDate.start) {
        csvContent +=
          'From,"' +
          moment(vm.selectedDate.start).format('DD/MM/YYYY') +
          '",To,"' +
          moment(vm.selectedDate.end).format('DD/MM/YYYY') +
          '"\r\n'
      }

      csvContent += 'Inbox Register Report by Date\r\n'
      csvContent += 'Intent, Count' + '\r\n'

      $.each(vm.data, function (index, item) {
        csvContent += item.intent + ',' + item.count + '\r\n'
      })

      vm.exportCsv(csvContent, 'crm')
    }
  }
}
</script>

<style scoped>
.v-select__selection.v-select__selection--comma {
  color: #ff817c;
}
</style>



// WEBPACK FOOTER //
// src/components/view/dashboard/inbox/InboxStatRegister.vue